"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DCoreAssetObject = /** @class */ (function () {
    function DCoreAssetObject() {
        this.id = '';
        this.symbol = '';
        this.precision = 0;
        this.issuer = '';
        this.description = '';
        this.monitored_asset_opts = null;
        this.options = {};
        this.dynamic_asset_data_id = '';
    }
    return DCoreAssetObject;
}());
exports.DCoreAssetObject = DCoreAssetObject;
var UserIssuedAssetInfo = /** @class */ (function () {
    function UserIssuedAssetInfo() {
        this.newIssuer = null;
        this.description = null;
        this.maxSupply = null;
        this.coreExchange = null;
        this.isExchangable = null;
    }
    return UserIssuedAssetInfo;
}());
exports.UserIssuedAssetInfo = UserIssuedAssetInfo;
var AssetError;
(function (AssetError) {
    AssetError["unable_to_list_assets"] = "unable_to_list_assets";
    AssetError["api_connection_failed"] = "api_connection_failed";
    AssetError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    AssetError["asset_issue_failure"] = "asset_issue_failure";
    AssetError["failed_to_fetch_account"] = "failed_to_fetch_account";
    AssetError["asset_not_found"] = "asset_not_found";
    AssetError["database_operation_failed"] = "database_operation_failed";
    AssetError["syntactic_error"] = "syntactic_error";
    AssetError["invalid_parameters"] = "invalid_parameters";
})(AssetError = exports.AssetError || (exports.AssetError = {}));
//# sourceMappingURL=asset.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/model/asset.js
// module id = 39
// module chunks = 0